import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import '.././AdminApp.scss'
import { useSelector, useDispatch } from 'react-redux'

function _AdminSidebar () {

  const dashboardData = useSelector(state=>state.dashboard.dashboardData)

  const menuItems = [
    { name: 'Dashboard', link: '/admin/dashboard' },
    { name: 'Items', link: '/admin/items', subMenu: [
      { name: 'Categories', link: '/admin/categories' },
      { name: 'Sizes', link: '/admin/sizes' },
      { name: 'Substrates', link: '/admin/substrates' },
      { name: 'Colors', link: '#' },
    ] },
    { name: 'Orders', link: '/admin/orders', badge: dashboardData.newOrders },
    { name: 'Discounts', link: '/admin/discounts' },
    { name: 'Client Requests', link: '/admin/clientRequests', badge: dashboardData.newRequests },
    { name: 'Partners', link: '/admin/partners' },
    { name: 'Users', link: '/admin/users' },
    { name: 'Content', link: '/admin/contents' },
  ]

  return (
    <React.Fragment>
      <div className='sidebar'>
        <div className='logo'>
          <a href='/'>
            <img src='/logo_horizontal_woslogan.png' />
          </a>
        </div>
        <div className='menu'>
          <ul>
            {menuItems.map((item, index) => (
              <li key={index}>
                <Link to={item.link} className={`menu-link ${window.location.pathname.includes(item.link) ? 'active' : ''}`}>
                  {item.name}
                  {item.badge > 0 && <span className="info-badge">{item.badge}</span>}
                </Link>
                {item.subMenu && (
                  <ul className="submenu">
                    {item.subMenu.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link to={subItem.link} className={`menu-link ${window.location.pathname.includes(subItem.link) ? 'active' : ''}`}>
                          {subItem.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className='footer'>
          <Link className='log-out' to='/logout'>
            Log out
          </Link>
        </div>
      </div>
    </React.Fragment>
  )
}

export default _AdminSidebar
